import React from 'react';
import { useCart } from '../contexts/CartContext';
import { X, ShoppingCart, Plus, Minus, Trash2 } from 'lucide-react';
export function CartPopup() {
  const {
    items,
    isOpen,
    closeCart,
    updateQuantity,
    removeItem,
    totalItems,
    totalPrice
  } = useCart();
  if (!isOpen) return null;
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 z-40 transition-opacity" onClick={closeCart} data-id="element-20" />

      {/* Cart Popup */}
      <div className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl z-50 flex flex-col" data-id="element-21">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-22">
          <div className="flex items-center gap-3" data-id="element-23">
            <ShoppingCart className="w-6 h-6 text-brand-red" data-id="element-24" />
            <h2 className="text-2xl font-bold text-brand-black" data-id="element-25">
              Your Cart ({totalItems})
            </h2>
          </div>
          <button onClick={closeCart} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Close cart" data-id="element-26">
            <X className="w-6 h-6 text-gray-600" data-id="element-27" />
          </button>
        </div>

        {/* Cart Items */}
        <div className="flex-1 overflow-y-auto p-6" data-id="element-28">
          {items.length === 0 ? <div className="flex flex-col items-center justify-center h-full text-center" data-id="element-29">
              <ShoppingCart className="w-16 h-16 text-gray-300 mb-4" data-id="element-30" />
              <p className="text-lg text-gray-600 mb-2" data-id="element-31">Your cart is empty</p>
              <p className="text-sm text-gray-500" data-id="element-32">Add items to get started</p>
            </div> : <div className="space-y-4" data-id="element-33">
              {items.map(item => <div key={item.id} className="flex gap-4 p-4 bg-gray-50 rounded-lg" data-id="element-34">
                  {item.image && <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded-lg" data-id="element-35" />}
                  <div className="flex-1" data-id="element-36">
                    <h3 className="font-semibold text-brand-black mb-1" data-id="element-37">
                      {item.name}
                    </h3>
                    <p className="text-brand-red font-bold mb-3" data-id="element-38">
                      ${item.price.toFixed(2)}
                    </p>
                    <div className="flex items-center gap-3" data-id="element-39">
                      <button onClick={() => updateQuantity(item.id, item.quantity - 1)} className="p-1 hover:bg-gray-200 rounded transition-colors" aria-label="Decrease quantity" data-id="element-40">
                        <Minus className="w-4 h-4" data-id="element-41" />
                      </button>
                      <span className="font-semibold w-8 text-center" data-id="element-42">
                        {item.quantity}
                      </span>
                      <button onClick={() => updateQuantity(item.id, item.quantity + 1)} className="p-1 hover:bg-gray-200 rounded transition-colors" aria-label="Increase quantity" data-id="element-43">
                        <Plus className="w-4 h-4" data-id="element-44" />
                      </button>
                      <button onClick={() => removeItem(item.id)} className="ml-auto p-2 hover:bg-red-50 text-red-600 rounded transition-colors" aria-label="Remove item" data-id="element-45">
                        <Trash2 className="w-4 h-4" data-id="element-46" />
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>}
        </div>

        {/* Footer */}
        {items.length > 0 && <div className="border-t border-gray-200 p-6 space-y-4" data-id="element-47">
            <div className="flex items-center justify-between text-lg" data-id="element-48">
              <span className="font-semibold text-brand-black" data-id="element-49">Total:</span>
              <span className="font-bold text-2xl text-brand-red" data-id="element-50">
                ${totalPrice.toFixed(2)}
              </span>
            </div>
            <a href="https://crowncontrol.shop/checkouts/cn/hWN97levku2cTO8ZNaWkRMfq/en-us?_r=AQABm6OC0PQxGKLV9JiCeb1ht4oAS3p9z2tHZtJJWY8JOSM&auto_redirect=false&edge_redirect=true&skip_shop_pay=true" className="w-full bg-brand-red text-white py-4 rounded-lg font-bold text-lg hover:bg-red-700 transition-colors shadow-lg block text-center" data-id="element-51">
              Proceed to Checkout
            </a>
          </div>}
      </div>
    </>;
}